import { Navigate, useLocation } from 'react-router-dom';
import LoadingScreen from '../Pages/LoadingScreen';

const RedirectVerifiedUsers = ({ children, verified, isLoading }) => {
  const location = useLocation();

  // Still loading KYC/verified data? Show nothing or a loader
  if (isLoading) return <LoadingScreen />;

  const isDashboardRoute = location.pathname.startsWith('/dashboard');

  // If the user is verified, redirect to home or the original path
  if (verified && isDashboardRoute) {
    const from = location.state?.from?.pathname || '/home';
    return <Navigate to={from} replace />;
  }

  // If user is not verified or no KYC data, show the dashboard content
  return children;
};

export default RedirectVerifiedUsers;
